"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_google_recaptcha_1 = require("react-google-recaptcha");
var styles = require("./CaptchaGenerator.css");
var CaptchaGenerator_config_1 = require("./CaptchaGenerator.config");
var CaptchaGenerator = /** @class */ (function (_super) {
    __extends(CaptchaGenerator, _super);
    function CaptchaGenerator(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (value) {
            if (_this.props.events && _this.props.events.onChange) {
                _this.props.events.onChange(value);
            }
        };
        _this.handleExpiration = function () {
            if (_this.props.events && _this.props.events.onExpired) {
                _this.props.events.onExpired();
            }
        };
        _this.handleError = function () {
            if (_this.props.events && _this.props.events.onErrered) {
                _this.props.events.onErrered();
            }
        };
        _this.reCaptchaRef = {};
        return _this;
    }
    CaptchaGenerator.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.options && nextProps.options.reset === true &&
            this.reCaptchaRef && this.reCaptchaRef.reset) {
            this.reCaptchaRef.reset();
        }
    };
    CaptchaGenerator.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: styles.app },
            React.createElement("div", { className: styles.innerStyle },
                React.createElement(react_google_recaptcha_1.default, { theme: "light", ref: function (e) { return (_this.reCaptchaRef = e); }, sitekey: CaptchaGenerator_config_1.CaptchaConfig.attSiteKeys.siteKey, onChange: this.handleChange, onExpired: this.handleExpiration, onErrored: this.handleError }))));
    };
    return CaptchaGenerator;
}(React.Component));
exports.default = CaptchaGenerator;
//# sourceMappingURL=CaptchaGenerator.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CaptchaGenerator/CaptchaGenerator.js
// module id = 1106
// module chunks = 8